import Vue from 'vue'
export default [
    {
        path: '',
        name: 'home',
        component: () =>
            import('./pages/Login/Login.vue')
    },
    {
        path: '/pages/login',
        name: 'login',
        component: () =>
            import('./pages/Login/Login.vue')
    },
    {
      path: "/pages/login-horas",
      name: "login-horas",
      component: () =>
        import('./pages/Login/Login.vue')
    },
    {
        path: '/logout',
        name: 'logout',
        component: () =>
            import('./pages/Logout/Logout.vue')
    },
    {
        path: '*',
        name: 'error404',
        component: () =>
            import('./pages/errors/error404/error404.vue')
    },
    {
        path: '/helpdesk/form',
        name: 'helpdesk-form',
        component: () =>
            import('./pages/HelpDeskForm/HelpDeskForm.vue')
    },

    {
        path: '',
        component: () =>
            import('../../layouts/main/Main.vue'),
        children: [
            {
                path: '/general-page/:name',
                name: 'general-page',
                beforeEnter: (to, from, next) => {
                    const bearer = Vue.prototype.$session.get("bearer");
                    const bearerDefault = Vue.prototype.$session.get("bearerDefault");
                    const isProjectPlan = Vue.prototype.$session.get("isProject") ? Vue.prototype.$session.get("isProject") : false;
                    Vue.prototype.$session.set("bearer", bearerDefault);
                    let isAuthenticated = false;
                    if (bearer !== null && bearer !== undefined && bearer !== "") {
                        isAuthenticated = true;
                    } else {
                        isAuthenticated = false;
                    }
                    if (!isAuthenticated)
                      if (isProjectPlan) next("/pages/login-horas")
                      else
                  if (isProjectPlan) next("/pages/login-horas")
                  else next('/pages/login')
                    else next()

                },
                component: () =>
                    import('./pages/GeneralPage/GeneralPage.vue')
            },
            {
              path: '/forbidden',
              name: 'forbidden',
              meta: { layout: 'generalLayout' },
              component: () =>
                import('./pages/Forbidden/Forbidden.vue')
            },
        ]
    },
    {
        path: '/email-confirmation/:token',
        name: 'email-confirmation',
        component: () =>
                import('./pages/email-confirmation/emailConfirmation.vue'),
      },
      {
        path: "/forgot-password/:token",
        name: "forgot-password",
        component: () =>
                import("./pages/forgot-password/forgotPassword.vue"),
      },
]
